import { View, StyleSheet } from 'react-native';
import { Skeleton } from '../ui/Skeleton';

export function ProductLoadingState() {
  return (
    <View style={styles.container}>
      {[...Array(4)].map((_, index) => (
        <View key={index} style={styles.card}>
          <Skeleton height={200} borderRadius={8} />
          <View style={styles.content}>
            <Skeleton width={150} height={20} borderRadius={4} />
            <Skeleton width={80} height={24} borderRadius={4} />
            <View style={styles.badges}>
              <Skeleton width={60} height={24} borderRadius={12} />
              <Skeleton width={60} height={24} borderRadius={12} />
            </View>
          </View>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 8,
  },
  card: {
    width: '50%',
    padding: 8,
  },
  content: {
    padding: 12,
    gap: 8,
  },
  badges: {
    flexDirection: 'row',
    gap: 8,
  },
}); 